export type UserRole = 'user' | 'mod' | 'admin' | 'super_admin';

export interface User {
  id: string;
  email: string;
  name: string;
  credits: number;
  isAdmin: boolean;
  role: UserRole;
  createdAt?: string;
}

export interface AuthResponse {
  user: User;
  token: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  name: string;
}
